import { calculateMaxDaresByPlatform, calculateMaxDaresForBestPlatform, } from 'root/src/shared/util/calculateMaxDares';
import { useDropEvent } from 'root/src/client/logic/dropEvent/hooks/useDropEvent';
import { DarePlatform } from 'root/src/shared/@types/platforms';
import { useUserCreatorData } from 'root/src/client/logic/auth/hooks/useUser';
import { getClassifiedDarePlatform, isDareAnyPlatform, } from 'root/src/shared/drops/helpers/dropDare.helpers';
export function useMaxDaresByPlatforms(params = {}) {
    var _a, _b;
    const { platforms = Object.values(DarePlatform), fallbackDrop } = params;
    const { connectedPlatforms, averageCcv = 0, averageYoutubeViews = 0, averageYoutubeShortsViews = 0, tiktokFollowers = 0, } = useUserCreatorData();
    const campaign = (_a = useDropEvent()) !== null && _a !== void 0 ? _a : fallbackDrop;
    if (!campaign) {
        return 0;
    }
    if (isDareAnyPlatform({ platforms })) {
        const bestPlatform = calculateMaxDaresForBestPlatform({
            averageCcv,
            averageYoutubeViews,
            averageYoutubeShortsViews,
            tiktokFollowers,
            campaign,
            connectedPlatforms,
        });
        return (_b = bestPlatform === null || bestPlatform === void 0 ? void 0 : bestPlatform.maxDares) !== null && _b !== void 0 ? _b : 0;
    }
    const maxDaresByPlatform = platforms.map((darePlatform) => {
        const darePlatformClassified = getClassifiedDarePlatform(darePlatform);
        if (!darePlatformClassified) {
            return campaign.dares
                .filter(dare => dare.platforms.includes(darePlatform)).length;
        }
        if (!connectedPlatforms.includes(darePlatformClassified)) {
            return 0;
        }
        return calculateMaxDaresByPlatform({
            platform: darePlatformClassified,
            campaign,
            averageYoutubeViews,
            averageYoutubeShortsViews,
            tiktokFollowers,
            averageCcv,
        });
    });
    return Math.max(...maxDaresByPlatform);
}
